import { z } from 'zod';

export const RegistrationOptionDaoSchema = z.object({
    source: z
        .union([z.literal('report'), z.unknown()])
        .transform((value) => (value === 'report' ? 'report' : null)),
});
